module.exports = __webpack_public_path__ + "static/media/profile-dark.9722e7a4.png";